import { ApolloLink } from '@apollo/client';

interface MutationConsistencyExtension {
  status?: unknown;
  token?: unknown;
}

function isValidToken(token: unknown): token is string {
  return typeof token === 'string' && /^[\x21-\x7e]+$/.test(token);
}

function getIssuedToken(extensions: Record<string, unknown> | undefined) {
  const mutationConsistency = extensions?.mutationConsistency;
  if (
    !mutationConsistency ||
    typeof mutationConsistency !== 'object' ||
    !('status' in mutationConsistency) ||
    !('token' in mutationConsistency)
  ) {
    return null;
  }

  const { status, token } = mutationConsistency as MutationConsistencyExtension;
  return status === 'issued' && isValidToken(token) ? token : null;
}

export function createMutationConsistencyLink() {
  let token: string | null = null;

  return new ApolloLink((operation, forward) => {
    if (token) {
      operation.extensions = {
        ...operation.extensions,
        mutationConsistency: { token },
      };
    }

    return forward(operation).map((response) => {
      token = getIssuedToken(response.extensions) ?? token;
      return response;
    });
  });
}
